var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGridAdvanced = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 7.66601C6.6665 7.11373 7.11422 6.66602 7.6665 6.66602H13.6665C14.2188 6.66602 14.6665 7.11373 14.6665 7.66602V24.3327C14.6665 24.885 14.2188 25.3327 13.6665 25.3327H7.6665C7.11422 25.3327 6.6665 24.885 6.6665 24.3327V7.66601Z",
    fill: "#8D939C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 7.66602C17.3335 7.11373 17.7812 6.66602 18.3335 6.66602H24.3335C24.8858 6.66602 25.3335 7.11373 25.3335 7.66602V13.666C25.3335 14.2183 24.8858 14.666 24.3335 14.666H18.3335C17.7812 14.666 17.3335 14.2183 17.3335 13.666V7.66602Z",
    fill: "#8D939C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 18.334C17.3335 17.7817 17.7812 17.334 18.3335 17.334H24.3335C24.8858 17.334 25.3335 17.7817 25.3335 18.334V24.334C25.3335 24.8863 24.8858 25.334 24.3335 25.334H18.3335C17.7812 25.334 17.3335 24.8863 17.3335 24.334V18.334Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGridAdvanced);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_grid_advanced.863dd8f61dae8f370cf799d11014069e.svg";